export function shouldUseLocalDevFeatureFlagOverrides(): boolean {
  return (
    process.env.NODE_ENV !== "production" &&
    process.env.NEXT_PUBLIC_POSTHOG_ENABLED !== "true"
  )
}
